import { DiagnosticCode } from '../../../../DiagnosticCode';
import { DiagnosticMessage } from '../../../../DiagnosticMessage';
import { BuiltinMemberCall } from '../../BuiltinMemberCall';
export class AddressFrom extends BuiltinMemberCall {
    emitCall(sb, _func, node, options) {
        const address = sb.context.analysis.extractLiteralAddress(node);
        if (address === undefined) {
            sb.context.reportError(node, DiagnosticCode.InvalidLiteral, DiagnosticMessage.InvalidAddress);
            return;
        }
        sb.emitPushBuffer(node, address);
        sb.emitHelper(node, options, sb.helpers.wrapBuffer);
    }
}

//# sourceMappingURL=from.js.map
